import PokemonSelectInput from "../../../components/PokemonSelectInput"
import type { PokemonOption } from "../../../types/pokemon"

interface DefencePokemonSelectProps {
  pokemonOptions: PokemonOption[]
  handleAddAttackPokemon: (event: any, newValue: any) => void
}

function DefencePokemonSelect({ pokemonOptions, handleAddAttackPokemon }: DefencePokemonSelectProps) {
  return (
    <PokemonSelectInput
      pokemonOptions={pokemonOptions}
      handleAddAttackPokemon={handleAddAttackPokemon}
      label="防御ポケモンを追加"
      placeholder="防御ポケモンを選択して追加"
    />
  )
}

export default DefencePokemonSelect
